import {
  stopRenderer,
  renderShipperOrderShippers,
  convertCMtoMeters,
  getJourneyPallets,
  warningRenderer,
  dateFormatter,
  getShipmentInfoFromStops,
} from '../utils';

const EU_template = (journey, offerLink) => {
  const {
    item_height,
    stops,
    extras,
    id,
    net_full_cost,
    total_weight,
    start_time_from,
    end_time_to,
    shipper_orders,
  } = journey;

  const country = 'UK';
  const maxHeight = convertCMtoMeters(item_height);
  const stopsToRender = stopRenderer(stops, country).join('');
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const payload = getJourneyPallets(journey, country);
  const warning = warningRenderer(extras, country);
  const when = dateFormatter(start_time_from, end_time_to, country);
  const shippers = renderShipperOrderShippers(shipper_orders);
  const deepLink = `${offerLink}${id}`;

  return `
NEW JOB:

WHEN: ${when}

COMPANY: ${shippers}

We pay you: ${net_full_cost} € + VAT
Total weight: ${total_weight} Kg
Payload: ${payload}
Max. pallet height: ${maxHeight}m

${stopsInfo.PICKUP} Pickup(s), ${stopsInfo.DROPOFF} Dropoff(s)
${stopsToRender}
${warning}

If you have the app installed click here to accept the job:
${deepLink}


Or reply with the following information:
- The reference number (${id})
- The registration number of the vehicle that will be used for the job and the name of the driver
    `;
};

export default EU_template;
